export default __webpack_public_path__ + "static/media/@thesapphirecat.ad8129be.jpeg";